import { render, staticRenderFns } from "./ButtonActivable.vue?vue&type=template&id=c5496754&"
import script from "./ButtonActivable.vue?vue&type=script&lang=js&"
export * from "./ButtonActivable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports